import { useTranslation } from "@opendash/i18n";
import { Tooltip } from "antd";
import React from "react";
import { TicketManager, useTicketData } from "../..";
import { SourceFilterIcon } from "./SourceFilterIcon";
import { SourceFilterLabel } from "./SourceFilterLabel";

type Props = {
  filterManager?: TicketManager;
  onClick?: () => void;
  asIcon?: boolean;
};

export const TicketSourceFilterTag = (props: Props) => {
  const t = useTranslation();
  const { source } = useTicketData();
  if (!source) return undefined;

  function toggleFilter() {
    if (props.filterManager?.getFilter("source")?.value === source.id)
      props.filterManager?.removeFilter("source");
    else
      props.filterManager?.addFilter("source", {
        attribute: "source",
        value: source.id,
      });

    props.onClick?.();
  }

  const isFilterActive =
    props.filterManager?.getFilter("source")?.value === source.id;

  const color = isFilterActive ? "orange" : undefined;
  const title = t("maintenance:ticket.filter.source", { source: source.name });

  return (
    <Tooltip title={title}>
      {props.asIcon && (
        <SourceFilterIcon onClick={toggleFilter} color={color} />
      )}
      {!props.asIcon && (
        <SourceFilterLabel onClick={toggleFilter} color={color} />
      )}
    </Tooltip>
  );
};
